// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ms-container {
  background: none;
  position: relative;
  width: 100%;
}
.ms-container:before {
  content: '\\f061';
  font-family: 'FontAwesome';
  display: block;
  visibility: visible;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -7px;
  margin-top: -10px;
  font-size: 1.4em;
}
.ms-header {
  font-size: 1.2em;
  font-weight: bold;
  line-height: 22px;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid #cccccc;
}
.ms-container .ms-selectable li.ms-hover,
.ms-container .ms-selection li.ms-hover {
  background-color: #004ebc;
}
.ms-container .ms-selectable li:hover {
  background-color: #4aba32;
}
.ms-container .ms-selection li:hover {
  background-color: #e73c27;
}
.ms-elem-selectable > span:before,
.ms-elem-selection > span:before {
  font-family: 'FontAwesome';
  visibility: visible;
  display: inline-block;
  padding-right: 5px;
}
.ms-elem-selectable > span:before {
  content: '\\f067';
}
.ms-elem-selection > span:before {
  content: '\\f00c';
}
.ms-container .ms-selection li:hover > span:before {
  content: '\\f00d';
  padding-right: 8px;
}
.ms-input-group {
  margin-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./corehq/apps/hqwebapp/static/hqwebapp/less/components/multiselect/multiselect.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;AACF;AAEA;EACE,gBAAA;EACA,0BAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAAF;AAGA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AADF;AAIA;;EAEE,yBAAA;AAFF;AAKA;EACE,yBAAA;AAHF;AAMA;EACE,yBAAA;AAJF;AAOA;;EAEE,0BAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;AALF;AAQA;EACE,gBAAA;AANF;AASA;EACE,gBAAA;AAPF;AAUA;EACE,gBAAA;EACA,kBAAA;AARF;AAWA;EACE,kBAAA;AATF","sourcesContent":[".ms-container {\n  background: none;\n  position: relative;\n  width: 100%;\n}\n\n.ms-container:before {\n  content: '\\f061';\n  font-family: 'FontAwesome';\n  display: block;\n  visibility: visible;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -7px;\n  margin-top: -10px;\n  font-size: 1.4em;\n}\n\n.ms-header {\n  font-size: 1.2em;\n  font-weight: bold;\n  line-height: 22px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  margin-bottom: 5px;\n  border-bottom: 1px solid #cccccc;\n}\n\n.ms-container .ms-selectable li.ms-hover,\n.ms-container .ms-selection li.ms-hover {\n  background-color: #004ebc;\n}\n\n.ms-container .ms-selectable li:hover {\n  background-color: #4aba32;\n}\n\n.ms-container .ms-selection li:hover {\n  background-color: #e73c27;\n}\n\n.ms-elem-selectable > span:before,\n.ms-elem-selection > span:before {\n  font-family: 'FontAwesome';\n  visibility: visible;\n  display: inline-block;\n  padding-right: 5px;\n}\n\n.ms-elem-selectable > span:before {\n  content: '\\f067';\n}\n\n.ms-elem-selection > span:before {\n  content: '\\f00c';\n}\n\n.ms-container .ms-selection li:hover > span:before {\n  content: '\\f00d';\n  padding-right: 8px;\n}\n\n.ms-input-group {\n  margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
